/* ==========================================================================
   BBC · Quiz de personnalisation
   Vanilla JS. Un seul fetch catalogue (via product-classifier.js), tout le
   reste tourne en memoire. Reponses persistees en sessionStorage.
   Le focus clavier n'est deplace qu'apres une interaction dans le quiz,
   sinon le navigateur ferait defiler la page jusqu'au quiz au chargement.
   ====================================================================== */
(function () {
  "use strict";

  var ANSWERS_KEY = "bbc_quiz_answers_v1";
  var root = document.querySelector("[data-bbc-quiz]");
  if (!root || !window.BBCClassifier) return;

  var normalize = window.BBCClassifier.normalize;
  var products = [];
  var answers = {};
  var order = [];
  var cursor = 0;
  var interacted = false;

  var QUESTIONS = [
    { id: "typeProduit", label: "Qu'est-ce que tu cherches aujourd'hui ?", options: [
      { v: "vetement", l: "Un vêtement" }, { v: "bijou", l: "Un bijou" }, { v: "indecis", l: "Je ne sais pas encore" } ] },
    { id: "coupe", label: "Tu te sens mieux dans une pièce…", skipIf: function (a) { return a.typeProduit === "bijou"; }, options: [
      { v: "ajustee", l: "Ajustée, près du corps" }, { v: "fluide", l: "Fluide, qui flotte" }, { v: "structuree", l: "Structurée, qui dessine" } ] },
    { id: "lingerieRenfort", label: "As-tu besoin d'un soutien renforcé (forte poitrine, maintien) ?", skipIf: function (a) { return a.typeProduit === "bijou"; }, options: [
      { v: "oui", l: "Oui" }, { v: "non", l: "Non" }, { v: "", l: "Pas concernée" } ] },
    { id: "occasion", label: "Pour quel moment cherches-tu une pièce ?", skipIf: function (a) { return a.typeProduit === "bijou"; }, options: [
      { v: "quotidien", l: "Le quotidien, le bureau" }, { v: "soiree", l: "Une soirée, un événement" }, { v: "ceremonie", l: "Une cérémonie (mariage, gala)" }, { v: "", l: "Je découvre juste" } ] },
    { id: "valeur", label: "Qu'est-ce qui te ferait le plus craquer ?", skipIf: function (a) { return a.typeProduit === "bijou"; }, options: [
      { v: "exclusivite", l: "Une pièce unique, introuvable ailleurs" }, { v: "artisanat", l: "Le savoir-faire artisanal français" }, { v: "fonctionnel", l: "Un système malin qui s'adapte au corps" } ] },
    { id: "styleBijou", label: "Quel style de bijou te correspond ?", skipIf: function (a) { return a.typeProduit !== "bijou"; }, options: [
      { v: "delicat", l: "Délicat et discret" }, { v: "statement", l: "Une pièce qui se voit" }, { v: "artisanat", l: "Peu importe, je veux du fait main unique" } ] },
    { id: "budget", label: "Ton budget pour cette pièce ?", options: [
      { v: "0-100", l: "Moins de 100 €" }, { v: "100-250", l: "De 100 à 250 €" }, { v: "250-99999", l: "250 € et plus" }, { v: "", l: "Pas de limite" } ] },
    { id: "exclusions", multi: true, label: "Une matière ou une couleur à éviter ?", hint: "Plusieurs choix possibles, ou passe directement.", options: [
      { v: "cuir", l: "Cuir" }, { v: "imprime", l: "Imprimés" }, { v: "paillette", l: "Paillettes" }, { v: "", l: "Aucune" } ] }
  ];

  function matchProducts(pool, a) {
    var list = pool.slice();
    if (a.typeProduit === "bijou") list = list.filter(function (p) { return p.categorie === "bijoux"; });
    else if (a.typeProduit === "vetement") list = list.filter(function (p) { return p.categorie !== "bijoux"; });
    if (a.budget) {
      var b = a.budget.split("-"), lo = parseFloat(b[0]), hi = parseFloat(b[1]);
      list = list.filter(function (p) { return p.prix >= lo && p.prix <= hi; });
    }
    if (a.exclusions && a.exclusions.length) {
      list = list.filter(function (p) { return !a.exclusions.some(function (ex) { return p.rawText.indexOf(normalize(ex)) !== -1; }); });
    }
    var forced = [];
    if (a.lingerieRenfort === "oui") forced = list.filter(function (p) { return p.lingerieRenfort; }).slice(0, 1);
    var scored = list
      .filter(function (p) { return forced.indexOf(p) === -1; })
      .map(function (p) {
        var score = 0;
        if (a.valeur && p.valeur === a.valeur) score += 2;
        if (a.coupe && p.coupe === a.coupe) score += 1;
        if (a.occasion && p.occasion === a.occasion) score += 1;
        if (a.styleBijou === "artisanat" && p.valeur === "artisanat") score += 2;
        if (a.styleBijou === "delicat" && p.prix <= 70) score += 1;
        if (a.styleBijou === "statement" && p.prix > 70) score += 1;
        if (a.lingerieRenfort === "non" && p.lingerieRenfort) score -= 2;
        return { p: p, score: score };
      })
      .sort(function (x, y) { return y.score - x.score; })
      .map(function (o) { return o.p; });
    var out = forced.concat(scored).slice(0, 4);
    if (!out.length) {
      out = pool.slice().sort(function (x, y) { return x.prix - y.prix; }).slice(0, 4);
      out.fallback = true;
    }
    return out;
  }

  function synthese(a) {
    var femme = { exclusivite: "qui aime les pièces uniques", artisanat: "sensible au travail fait main", fonctionnel: "qui veut du pratique et du malin" }[a.valeur];
    var pref = { ajustee: "les coupes ajustées", fluide: "les coupes fluides", structuree: "les coupes structurées" }[a.coupe];
    if (a.typeProduit === "bijou") pref = "les bijoux faits main";
    var moment = { quotidien: "le quotidien", soiree: "la soirée", ceremonie: "les grandes occasions" }[a.occasion];
    var s = "Tu es une femme";
    s += femme ? " " + femme : " qui cherche du vrai Made in France";
    if (pref) s += ", avec un faible pour " + pref;
    if (moment) s += ", pour " + moment;
    return s + ".";
  }

  function esc(s) { return String(s).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;"); }
  function money(v) { return v.toLocaleString("fr-FR", { minimumFractionDigits: 0, maximumFractionDigits: 0 }) + " €"; }
  function activeQuestions() { return QUESTIONS.filter(function (q) { return !(q.skipIf && q.skipIf(answers)); }); }
  function save() { try { sessionStorage.setItem(ANSWERS_KEY, JSON.stringify(answers)); } catch (e) {} }
  function focusFirst(sel) {
    if (!interacted) return;
    var el = root.querySelector(sel);
    if (el) { try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); } }
  }

  function renderQuestion() {
    order = activeQuestions();
    if (cursor >= order.length) return renderResult();
    var q = order[cursor];
    var pct = Math.round((cursor / order.length) * 100);
    var current = answers[q.id];
    var html = '<div class="bbcq__bar"><i style="width:' + pct + '%"></i></div>';
    html += '<p class="bbcq__step">Question ' + (cursor + 1) + ' sur ' + order.length + '</p>';
    html += '<h3 class="bbcq__q">' + esc(q.label) + '</h3>';
    if (q.hint) html += '<p class="bbcq__hint">' + esc(q.hint) + '</p>';
    html += '<div class="bbcq__opts" role="group">';
    q.options.forEach(function (o) {
      var on;
      if (q.multi) { var arr = current || []; on = o.v === "" ? arr.length === 0 : arr.indexOf(o.v) !== -1; }
      else { on = current === o.v; }
      html += '<button type="button" class="bbcq__opt' + (on ? " is-on" : "") + '" data-val="' + esc(o.v) + '">' + esc(o.l) + '</button>';
    });
    html += '</div><div class="bbcq__nav">';
    if (cursor > 0) html += '<button type="button" class="bbcq__back" data-back>&larr; Précédent</button>';
    if (q.multi) html += '<button type="button" class="bbcq__next" data-next>Voir mes recommandations</button>';
    html += '</div>';
    root.innerHTML = html;

    root.querySelectorAll("[data-val]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        interacted = true;
        var v = btn.getAttribute("data-val");
        if (q.multi) {
          var arr = answers[q.id] || [];
          if (v === "") arr = [];
          else if (arr.indexOf(v) !== -1) arr = arr.filter(function (x) { return x !== v; });
          else arr = arr.concat([v]);
          answers[q.id] = arr; save(); renderQuestion();
        } else {
          answers[q.id] = v; save(); cursor++; renderQuestion();
        }
      });
    });
    var back = root.querySelector("[data-back]");
    if (back) back.addEventListener("click", function () { interacted = true; cursor = Math.max(0, cursor - 1); renderQuestion(); });
    var next = root.querySelector("[data-next]");
    if (next) next.addEventListener("click", function () { interacted = true; cursor++; renderQuestion(); });
    focusFirst(".bbcq__opt");
  }

  function renderResult() {
    var picks = matchProducts(products, answers);
    var html = '<div class="bbcq__bar"><i style="width:100%"></i></div>';
    html += '<p class="bbcq__step">Ta sélection</p>';
    html += '<h3 class="bbcq__synth">' + esc(synthese(answers)) + '</h3>';
    if (picks.fallback) html += '<p class="bbcq__hint">Aucune pièce ne cochait toutes tes cases. Voici celles qui rentrent dans ton budget.</p>';
    html += '<div class="bbcq__grid">';
    picks.forEach(function (p) {
      html += '<a class="bbcq__card" href="/products/' + esc(p.handle) + '"><div class="bbcq__media">';
      if (p.image) html += '<img src="' + esc(p.image) + '" alt="' + esc(p.title) + ', ' + esc(p.vendor) + ', fabriqué en France" loading="lazy">';
      html += '<span class="bbcq__mif"><i aria-hidden="true"></i>Made in France</span></div>';
      html += '<p class="bbcq__vendor">' + esc(p.vendor) + '</p>';
      html += '<h4 class="bbcq__name">' + esc(p.title) + '</h4>';
      html += '<p class="bbcq__price">' + money(p.prix) + '</p></a>';
    });
    html += '</div>';
    if (answers.valeur === "artisanat" || answers.styleBijou === "artisanat") {
      html += '<a class="bbcq__passeport" href="#bbc-passeport"><strong>Le savoir-faire, ça se vérifie.</strong>';
      html += "<span>Chaque pièce a son passeport de fabrication : qui l'a faite, où, et où va chaque euro. &rarr;</span></a>";
    }
    html += '<div class="bbcq__nav bbcq__nav--end"><button type="button" class="bbcq__back" data-restart>Refaire le quiz</button></div>';
    root.innerHTML = html;
    root.querySelector("[data-restart]").addEventListener("click", function () { interacted = true; restart(); });
  }

  function renderResume() {
    root.innerHTML = '<p class="bbcq__step">On se souvient de toi</p>' +
      '<h3 class="bbcq__q">On a gardé tes préférences en tête.</h3>' +
      '<div class="bbcq__nav bbcq__nav--end">' +
      '<button type="button" class="bbcq__next" data-see>Voir mes recommandations</button>' +
      '<button type="button" class="bbcq__back" data-restart>Refaire le quiz</button></div>';
    root.querySelector("[data-see]").addEventListener("click", function () { interacted = true; order = activeQuestions(); cursor = order.length; renderResult(); });
    root.querySelector("[data-restart]").addEventListener("click", function () { interacted = true; restart(); });
  }

  function restart() {
    answers = {}; cursor = 0;
    try { sessionStorage.removeItem(ANSWERS_KEY); } catch (e) {}
    renderQuestion();
  }

  root.innerHTML = '<p class="bbcq__step">Un instant…</p>';
  window.BBCClassifier.load().then(function (list) {
    products = list;
    var saved = null;
    try { saved = JSON.parse(sessionStorage.getItem(ANSWERS_KEY) || "null"); } catch (e) {}
    if (saved && saved.typeProduit) { answers = saved; renderResume(); }
    else { renderQuestion(); }
  }).catch(function () {
    root.innerHTML = '<p class="bbcq__hint">Le quiz ne répond pas pour le moment. <a href="/collections/all">Voir tout le catalogue</a></p>';
  });
})();
